import type { ConsumableMatrixItem } from "@product-details/containers/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.types";

export const getMatrixItemByFlavor = (
  matrixItems: ConsumableMatrixItem[],
  flavourId: number | string | null
): ConsumableMatrixItem | undefined =>
  matrixItems.find((item) => {
    if (!flavourId) {
      return false;
    }

    return item.flavorDetails?.flavour === flavourId;
  });
